module.exports = __webpack_public_path__ + "img/project10_12.ddfd3b63.jpg";